// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"80eba1c4","276":"5d0c65bb","744":"b893e64e","787":"513cf44a","810":"7137fd5f"}[chunkId] + ".chunk.js";
};